import React from 'react';
import { LazySection } from './LazySection';
export function Urgencia() {
  return <LazySection className="bg-gradient-to-br from-rust to-[#7a3820] text-cream text-center !py-[70px] md:!py-[90px]" data-id="element-401">
      <div className="container-custom" data-id="element-402">
        <h2 className="text-cream text-[clamp(30px,4.5vw,46px)] max-w-[820px] mx-auto mb-6 leading-[1.2]" data-id="element-403">
          Cada año que pasa sin entender el{' '}
          <span className="highlight-keyword-light" data-id="element-404">origen</span> es otro año
          repitiendo lo mismo.
        </h2>
        <p className="text-[17px] text-cream/90 max-w-[640px] mx-auto mb-3.5" data-id="element-405">
          La urgencia ya la conocés: <strong data-id="element-406">es el tiempo que ya pasó.</strong>
        </p>
        <p className="text-[17px] text-cream/90 max-w-[640px] mx-auto" data-id="element-407">
          No necesitás más información.{' '}
          <strong data-id="element-408">
            Necesitás ver el{' '}
            <span className="highlight-keyword-light" data-id="element-409">origen</span>.
          </strong>
        </p>
      </div>
    </LazySection>;
}